import {IndividualConfig} from 'ngx-toastr/toastr/toastr-config';

const toastPushNotificationConfig = {
  closeButton: true,
  disableTimeOut: true,
  enableHtml: true,
  toastClass: 'ngx-toastr pasi-toast-push-notification'
} as IndividualConfig;

const toastHtmlConfig = {
  enableHtml: true
} as IndividualConfig;

export {
  toastPushNotificationConfig,
  toastHtmlConfig
}
